(() => {
  const rewriteLink = (anchor) => {
    const href = anchor.getAttribute('href');
    if (!href || !href.includes('premium-matcha-1')) return;
    let target;
    try {
      target = new URL(href, window.location.href);
    } catch {
      return;
    }
    if (target.origin !== window.location.origin || !/\/products\/premium-matcha-1\/?$/.test(target.pathname)) return;
    target.pathname = target.pathname.replace(/\/products\/premium-matcha-1\/?$/, '/products/premium-matcha-2');
    if (target.pathname === '/products/premium-matcha-2') {
      const localeRoot = window.Shopify?.routes?.root || '/';
      target.pathname = `${localeRoot.replace(/\/$/, '')}/products/premium-matcha-2`;
    }
    anchor.setAttribute('href', target.pathname + target.search + target.hash);
  };

  const rewriteWithin = (root) => {
    if (root.matches?.('a[href]')) rewriteLink(root);
    root.querySelectorAll?.('a[href*="premium-matcha-1"]').forEach(rewriteLink);
  };

  rewriteWithin(document);
  const observer = new MutationObserver((records) => {
    for (const record of records) {
      if (record.type === 'attributes') rewriteLink(record.target);
      else record.addedNodes.forEach(rewriteWithin);
    }
  });
  observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['href'] });

  if (!/\/products\/premium-matcha-2\/?$/.test(window.location.pathname)) return;

  const variantId = new URLSearchParams(window.location.search).get('variant');
  if (variantId && /^\d+$/.test(variantId)) {
    const input = document.querySelector(`.tpv input[name="id"][value="${variantId}"]`);
    if (input && !input.disabled) input.checked = true;
  }

  if (window.location.hash === '#looxReviews') {
    document.addEventListener('DOMContentLoaded', () => {
      const reviews = document.querySelector('[id^="TpvReviews-"]');
      if (reviews) reviews.scrollIntoView();
    }, { once: true });
  }
})();
